import React from "react";
import { Link } from "react-router-dom";
import { CalendarIcon, ClockIcon, UserIcon } from "@heroicons/react/24/outline";
import { Helmet } from "react-helmet";

interface BlogPost {
  id: string;
  title: string;
  excerpt: string;
  author: string;
  publishDate: string;
  readTime: string;
  slug: string;
  featured?: boolean;
  category: string;
  featuredImage?: string;
}

const blogPosts: BlogPost[] = [
  {
    id: "10",
    title: "Best Martial Arts Studio Software for Small Schools: Features, Benefits, and AI Advantages",
    excerpt: "Discover the best martial arts studio software for small schools. Compare features, benefits, and AI-powered solutions that help dojos save time, improve student retention, and grow. Complete 2025 comparison guide.",
    author: "DojoTrack Team",
    publishDate: "2025-11-23",
    readTime: "15 min read",
    slug: "best-martial-arts-studio-software-small-schools",
    featured: true,
    category: "Technology",
    featuredImage: "https://cdn.marblism.com/vEB0AzpFK7r.png"
  },
  {
    id: "9",
    title: "Automatic Monthly Payments vs Cash Payments for Martial Arts Studios: Which is Best?",
    excerpt: "Running a martial arts studio means making crucial decisions about payment collection. Discover the pros and cons of automatic monthly payments versus cash payments, and learn which approach will help your dojo thrive in today's competitive market.",
    author: "DojoTrack Team",
    publishDate: "2025-11-19",
    readTime: "14 min read",
    slug: "automatic-monthly-payments-vs-cash-payments-studios",
    featured: false,
    category: "Business Tips",
    featuredImage: "https://cdn.marblism.com/pwQMtRBlddo.webp"
  },
  {
    id: "8",
    title: "DojoTrack Setup: 10 Essential Steps",
    excerpt: "Setting up your martial arts studio management software doesn't have to feel like learning a new kata from scratch. This comprehensive guide walks you through the 10 essential steps to configure your martial arts CRM and transform how you manage your students, classes, and business operations.",
    author: "DojoTrack Team",
    publishDate: "2025-11-13",
    readTime: "12 min read",
    slug: "dojotrack-setup-10-essential-steps",
    featured: false,
    category: "Technology",
    featuredImage: "https://cdn.marblism.com/ywAxxhlmQqr.webp"
  },
  {
    id: "7",
    title: "Stop Wasting Time on Manual Tasks: 5 Dojo Management Software Features That Actually Work",
    excerpt: "Running a successful dojo means juggling dozens of daily tasks. If you're still relying on spreadsheets and handwritten logs, you're spending 10-15 hours per week on administrative work that could be automated.",
    author: "DojoTrack Team",
    publishDate: "2025-10-22",
    readTime: "12 min read",
    slug: "stop-wasting-time-manual-tasks-dojo-management-software-features",
    featured: false,
    category: "Technology",
    featuredImage: "https://cdn.marblism.com/jg_JbLYV_4j.webp"
  },
  {
    id: "6",
    title: "Stop Losing Students: 5 Steps How to Boost Retention and Revenue (Easy Guide for Martial Arts Schools)",
    excerpt: "Every martial arts school owner knows the gut-wrenching feeling of watching promising students walk out the door, never to return. Learn the 5 proven steps to boost retention and revenue.",
    author: "DojoTrack Team",
    publishDate: "2025-10-10",
    readTime: "15 min read",
    slug: "stop-losing-students-5-steps-boost-retention-revenue",
    featured: false,
    category: "Student Management",
    featuredImage: "https://cdn.marblism.com/8VYKro-3U0z.webp"
  },
  {
    id: "2",
    title: "The Ultimate Guide to Martial Arts School Automation: Everything You Need to Succeed in 2025",
    excerpt: "Running a successful martial arts school in 2025 isn't just about teaching perfect technique or building character: it's about mastering the business side too. Learn how automation can transform your dojo operations.",
    author: "DojoTrack Team",
    publishDate: "2025-09-09",
    readTime: "12 min read",
    slug: "ultimate-guide-martial-arts-school-automation-2025",
    featured: false,
    category: "Technology",
    featuredImage: "https://cdn.marblism.com/i7CydNDEqV6.webp"
  },
  {
    id: "5",
    title: "No Extra SMS Fees: DojoTrack's All-Inclusive Pricing Makes Communication Easy for Martial Arts Schools",
    excerpt: "Many martial arts CRMs pile on hidden SMS costs through add-ons, number fees, and per-message markups. DojoTrack keeps it simple: one subscription, full SMS features, and you pay Twilio at cost.",
    author: "DojoTrack Team",
    publishDate: "2025-09-22",
    readTime: "9 min read",
    slug: "no-extra-sms-fees-all-inclusive-pricing-dojotrack",
    category: "Technology",
    featuredImage: "https://cdn.marblism.com/R_Qi0VQuUfr.webp"
  },
  {
    id: "4",
    title: "Generic Fitness Software Vs Martial Arts CRM: Which Is Better For Your Dojo?",
    excerpt: "Running a successful dojo involves juggling class schedules, tracking student progress through belt ranks, managing family memberships, and coordinating tournaments. When it comes to choosing software, you're faced with a critical decision: generic fitness software or specialized martial arts CRM?",
    author: "DojoTrack Team",
    publishDate: "2025-09-20",
    readTime: "10 min read",
    slug: "generic-fitness-software-vs-martial-arts-crm",
    category: "Technology",
    featuredImage: "https://cdn.marblism.com/tNKjXUkMgdl.webp"
  },
  {
    id: "3",
    title: "How Smart Automation Instantly Connects Martial Arts Leads to Your Dojo (with SMS Booking Links)",
    excerpt: "Picture this: A parent researches martial arts schools online at 9 PM on a Tuesday night while their kid is asleep. They find your dojo's website, love what they see, and fill out your contact form. But by the time you see that inquiry the next morning and call them back, they've already visited two other schools and scheduled trial classes elsewhere.",
    author: "DojoTrack Team",
    publishDate: "2025-09-15",
    readTime: "8 min read",
    slug: "smart-automation-sms-booking-links-martial-arts",
    category: "Technology",
    featuredImage: "https://cdn.marblism.com/P7wrDrg_qAn.webp"
  },
  {
    id: "1",
    title: "5 Essential Tips for Running a Successful Martial Arts School",
    excerpt: "Discover the key strategies that successful martial arts school owners use to grow their business, retain students, and create a thriving community.",
    author: "DojoTrack Team",
    publishDate: "2024-01-15",
    readTime: "5 min read",
    slug: "5-essential-tips-martial-arts-school",
    category: "Business Tips",
    featuredImage: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=800&h=400&fit=crop&crop=center"
  },
  // {
  //   id: "3",
  //   title: "How to Increase Student Retention in Your Martial Arts Studio",
  //   excerpt: "Learn proven techniques to keep your students engaged and motivated, reducing dropout rates and building a loyal community.",
  //   author: "DojoTrack Team",
  //   publishDate: "2024-01-10",
  //   readTime: "4 min read",
  //   slug: "increase-student-retention-martial-arts",
  //   category: "Student Management",
  //   featuredImage: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=800&h=400&fit=crop&crop=center"
  // },
  // {
  //   id: "4",
  //   title: "The Complete Guide to Martial Arts School Marketing",
  //   excerpt: "From social media strategies to local advertising, discover comprehensive marketing approaches that work for martial arts schools.",
  //   author: "DojoTrack Team",
  //   publishDate: "2024-01-05",
  //   readTime: "7 min read",
  //   slug: "complete-guide-martial-arts-marketing",
  //   category: "Marketing",
  //   featuredImage: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&h=400&fit=crop&crop=center"
  // },
  // {
  //   id: "5",
  //   title: "Streamlining Your Martial Arts School Operations with Technology",
  //   excerpt: "Explore how modern software solutions can transform your martial arts school management and improve efficiency.",
  //   author: "DojoTrack Team",
  //   publishDate: "2023-12-28",
  //   readTime: "6 min read",
  //   slug: "streamlining-martial-arts-operations-technology",
  //   category: "Technology",
  //   featuredImage: "https://images.unsplash.com/photo-1551650975-87deedd944c3?w=800&h=400&fit=crop&crop=center"
  // }
];

const categories = ["All", "Business Tips", "Student Management", "Marketing", "Technology"];

export default function Blog() {
  return (
    <>
      <Helmet>
        <title>Martial Arts CRM Expert Blog | DojoTrack</title>
        <meta
          name="description"
          content="Expert insights, tips, and strategies for martial arts school owners. Learn from the leading authority on martial arts CRM and studio management software."
        />
        <meta
          name="keywords"
          content="martial arts blog, dojo management tips, martial arts CRM expert, studio management advice, martial arts business"
        />
        <meta name="author" content="DojoTrack LLC" />
        <meta
          property="og:title"
          content="Martial Arts CRM Expert Blog | DojoTrack"
        />
        <meta
          property="og:description"
          content="Expert insights, tips, and strategies for martial arts school owners. Learn from the leading authority on martial arts CRM and studio management software."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://dojotrack.com/blog" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Martial Arts CRM Expert Blog | DojoTrack"
        />
        <meta
          name="twitter:description"
          content="Expert insights, tips, and strategies for martial arts school owners. Learn from the leading authority on martial arts CRM and studio management software."
        />
        <link rel="canonical" href="https://dojotrack.com/blog" />
      </Helmet>
      <div className="bg-white dark:bg-gray-900">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-indigo-600 to-purple-600 dark:from-indigo-800 dark:to-purple-800">
        <div className="absolute inset-0 bg-black opacity-20"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20 lg:py-20">
          <div className="text-center">
            <h1 className="text-4xl font-bold tracking-tight text-white sm:text-5xl md:text-6xl">
              <span className="text-white">DojoTrack </span>
              <span className="bg-gradient-to-r from-yellow-300 to-orange-300 bg-clip-text text-transparent">Blog</span>
            </h1>
            <p className="mt-6 max-w-2xl mx-auto text-xl text-indigo-100">
              Insights, tips, and strategies for martial arts school owners and instructors
            </p>
          </div>
        </div>
      </div>

      {/* Featured Post */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 pb-12">
        {blogPosts.filter(post => post.featured).map((post) => (
          <div key={post.id} className="mb-16">
            <div className="bg-gradient-to-br from-indigo-50/80 to-purple-50/80 dark:from-indigo-900/30 dark:to-purple-900/30 rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="md:flex">
                {post.featuredImage && (
                  <div className="md:w-1/2">
                    <img 
                      src={post.featuredImage} 
                      alt={post.title}
                      className="w-full h-64 md:h-full object-cover hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                )}
                <div className="md:w-1/2 p-8">
                  <div className="flex items-center gap-2 mb-4">
                    <span className="px-3 py-1 text-xs font-semibold text-indigo-600 dark:text-indigo-400 bg-indigo-100 dark:bg-indigo-900/30 rounded-full">
                      Featured
                    </span>
                    <span className="px-3 py-1 text-xs font-semibold text-gray-600 dark:text-gray-400 bg-gray-100 dark:bg-gray-800 rounded-full">
                      {post.category}
                    </span>
                  </div>
                  <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
                    {post.title}
                  </h2>
                  <p className="text-lg text-gray-600 dark:text-gray-300 mb-6">
                    {post.excerpt}
                  </p>
                  <div className="flex items-center gap-4 text-xs text-gray-500 dark:text-gray-400 mb-6">
                    <div className="flex items-center gap-1">
                      <UserIcon className="h-3 w-3" />
                      <span>{post.author}</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <CalendarIcon className="h-3 w-3" />
                      <span>{new Date(post.publishDate).toLocaleDateString('en-US', { 
                        year: 'numeric', 
                        month: 'short', 
                        day: 'numeric' 
                      })}</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <ClockIcon className="h-3 w-3" />
                      <span>{post.readTime}</span>
                    </div>
                  </div>
                  <Link
                    to={`/blog/${post.slug}`}
                    className="inline-flex items-center px-8 py-4 border border-transparent text-base font-medium rounded-md text-white bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-500 hover:to-purple-500 transition-all duration-300 transform hover:scale-105 hover:shadow-xl"
                  >
                    Read Full Article
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Blog Posts Grid */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
        <h2 className="text-2xl font-bold text-center mb-12">
          <span className="bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">Latest Articles</span>
        </h2>
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {blogPosts.filter(post => !post.featured).map((post) => (
            <article key={post.id} className="bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 border border-gray-200 dark:border-gray-700 hover:border-indigo-300 dark:hover:border-indigo-600">
              {post.featuredImage && (
                <div className="h-48 overflow-hidden">
                  <img 
                    src={post.featuredImage} 
                    alt={post.title}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                  />
                </div>
              )}
              <div className="p-6">
                <div className="flex items-center gap-2 mb-4">
                  <span className="px-3 py-1 text-xs font-semibold text-gray-600 dark:text-gray-400 bg-gray-100 dark:bg-gray-700 rounded-full">
                    {post.category}
                  </span>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3 line-clamp-2">
                  {post.title}
                </h3>
                <p className="text-gray-600 dark:text-gray-300 mb-4 line-clamp-3">
                  {post.excerpt}
                </p>
                <div className="flex items-center gap-3 text-xs text-gray-500 dark:text-gray-400 mb-4">
                  <div className="flex items-center gap-1">
                    <UserIcon className="h-3 w-3" />
                    <span>{post.author}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <CalendarIcon className="h-3 w-3" />
                    <span>{new Date(post.publishDate).toLocaleDateString('en-US', { 
                      year: 'numeric', 
                      month: 'short', 
                      day: 'numeric' 
                    })}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <ClockIcon className="h-3 w-3" />
                    <span>{post.readTime}</span>
                  </div>
                </div>
                <Link
                  to={`/blog/${post.slug}`}
                  className="text-indigo-600 dark:text-indigo-400 hover:text-indigo-700 dark:hover:text-indigo-300 font-medium transition-colors hover:underline"
                >
                  Read More →
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>

    </div>
    </>
  );
} 